import * as React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  useMediaQuery,
  Box,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const ConfirmDialog = ({
  open,
  title,
  content,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  fullScreenOverride,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      fullScreen={fullScreenOverride ?? fullScreen}
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 2,
          boxShadow: 6,
          backgroundColor: theme.palette.background.paper,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          fontWeight: 600,
          fontSize: "1.25rem",
        }}
      >
        <WarningAmberIcon color="warning" />
        {title}
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ fontSize: "1rem", color: "text.secondary" }}>
          {content}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "flex-end", gap: 1 }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: 2, textTransform: "none" }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          sx={{ borderRadius: 2, textTransform: "none", boxShadow: 1 }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
